<section class="mb-4">
  <div class="d-flex justify-content-end">
    <a class="btn btn-sm btn-nz-outline-primary flex-0 dropdown-toggle"
       role="button"
       aria-expanded="false"
       data-bs-toggle="dropdown">
      <i class="me-2 fa-solid fa-tools" aria-hidden="true"></i>
      Групови действия
    </a>
    <ul class="dropdown-menu dropdown-menu-end">
      <li>
        <button class="dropdown-item"
                (click)="onOpenProfilePurchasesGroupActionsModal('group')">
          <i class="dropdown-item-icon text-muted fa-solid fa-layer-group" aria-hidden="true"></i>
          Групирай покупки
        </button>
      </li>
      <hr class="dropdown-divider">
      <li>
        <button class="dropdown-item"
                (click)="onOpenProfilePurchasesGroupActionsModal('delete')">
          <i class="dropdown-item-icon text-danger fa-solid fa-trash-can" aria-hidden="true"></i>
          Групово изтриване
        </button>
      </li>
    </ul>
  </div>
</section>
<section class="mb-4">
  <nz-search-input
    [searchValue]="searchValue"
    (onSearchValueChange)="onSearch($event)"
    placeholder="Търсене по потребител или обява...">
  </nz-search-input>
</section>
<section class="mb-4">
  <nz-search-result
    [totalResults]="this.totalResults"
    [sortOptions]="sortOptions"
    [selectedSortOption]="selectedSortOption"
    (onSortOptionChange)="onSort($event)">
  </nz-search-result>
</section>
@if (!loading) {
  @if (purchases.length === 0) {
    <h4 class="my-5 text-muted">
      Няма намерени покупки
    </h4>
  }
  <section>
    <ul class="list-unstyled" nzRestoreScrollPosition>
      @for (purchase of purchases; track purchase.purchaseHistoryId) {
        <li class="my-3 d-flex border shadow bg-white rounded-3">
          <a class="profile-card-image"
             [routerLink]="[appRoutes.root, appRoutes.ad, purchase.adId]">
            <nz-image [imageUrl]="environment.apiImageAdUrl + '/main/' + purchase.adId"/>
          </a>
          <div class="profile-card-body d-flex flex-column justify-content-between">
            <div class="d-flex justify-content-between">
              <div class="text-truncate">
                <a class="px-2 pb-0 btn btn-link d-block text-truncate text-decoration-none text-start"
                   [routerLink]="[appRoutes.root, appRoutes.ad, purchase.adId]">
                  <i class="small text-secondary fa-solid "
                     [ngClass]="purchase.adType === AdType.DirectSale ? 'fa-shopping-cart' : 'fa-gavel'">
                  </i>
                  {{ purchase.adTitle }}
                </a>
                <div class="px-2 text-truncate small text-muted">
                  Продавач:
                  <a class="text-decoration-none"
                     [routerLink]="[appRoutes.root, appRoutes.profile, purchase.sellerId]">
                    {{ purchase.sellerUsername }}
                  </a>
                </div>
                <div class="px-2 text-truncate small text-muted">
                  Крайна цена: <strong>{{ purchase.adPrice.toFixed(2) }}</strong> лв.
                </div>
              </div>
              <div class="dropdown">
                <button type="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        class="btn btn-light text-muted dropdown-button">
                  <i class="fa-solid fa-ellipsis-vertical"></i>
                </button>
                <ul class="dropdown-menu dropdown-menu-end rounded-end-0 shadow">
                  <li>
                    <a class="dropdown-item"
                       [routerLink]="[appRoutes.root, appRoutes.ad, purchase.adId]">
                      <i class="dropdown-item-icon text-muted fa-solid fa-eye" aria-hidden="true"></i>
                      Преглед на обявата
                    </a>
                  </li>
                  <li>
                    <a class="dropdown-item"
                       [routerLink]="[appRoutes.root, appRoutes.profile, purchase.sellerId]">
                      <i class="dropdown-item-icon text-muted fa-solid fa-user" aria-hidden="true"></i>
                      Преглед на продавача
                    </a>
                  </li>
                  <hr class="dropdown-divider">
                  <li>
                    <button class="dropdown-item"
                            (click)="showDeletePurchaseWarning(purchase)">
                      <i class="dropdown-item-icon text-danger fa-solid fa-trash-can" aria-hidden="true"></i>
                      Изтриване на известието
                    </button>
                  </li>
                </ul>
              </div>
            </div>
            <small class="p-2 pt-0 text-end text-muted">
              {{ purchase.dateTime | date: 'dd:MM:yyyy г. HH:mm ч.' }}
            </small>
          </div>
        </li>
      }
    </ul>
  </section>
} @else {
  <section class="my-5">
    <div class="text-center">
      <h1>
        <i class="text-dark fa-solid fa-spinner fa-spin"></i>
      </h1>
      <h5 class="text-muted">Зареждане...</h5>
    </div>
  </section>
}
@if (this.totalResults > defaultPageLimit) {
  <section class="py-4">
    <nz-pagination
      [totalResults]="totalResults"
      [selectedPage]="selectedPage"
      [selectedPageLimitOptionId]="selectedPageLimitOptionId"/>
  </section>
}
